import React, { useState } from "react";
import HeroSection from "../components/hero-section";
import ProductOverview from "../components/product-overview";
import FeaturesSection from "../components/features-section";
import RequestDemoModal from "../components/modals/request-demo.madal";
import Layout from "../components/layouts/main-layout";
import ContactUs from "../components/contact-us";

const HomePage = () => {
    const [isModalOpen, setModalOpen] = useState(false);

    return (
        <Layout openModal={() => setModalOpen(true)}>
            <HeroSection openModal={() => setModalOpen(true)} />
            <ProductOverview />
            <FeaturesSection />
            <ContactUs />
            <RequestDemoModal isOpen={isModalOpen} closeModal={() => setModalOpen(false)} />
        </Layout>
    );
};

export default HomePage;

